// @ts-strict-ignore
import Config from 'APP/Config'
import UrlBuilder from 'APP/Helpers/UrlBuilder'
import { Linking } from 'react-native'
import Alert from 'APP/Converse/Alert'
import I18n from 'APP/I18n'
import { navigationRef as Nav } from 'APP/Nav'
import { logger } from 'APP/Lib/Datadog'

export const handlePressContactSupport = async () => {
  const customContactUs = Config.CUSTOM_SUPPORT_PAGE

  if (customContactUs) {
    return Nav.navigate('contactUs')
  }

  const url = UrlBuilder.supportEmailUrl()
  const canOpen = await Linking.canOpenURL(url)

  if (!canOpen) return

  try {
    await Linking.openURL(url)
  } catch (e) {
    logger.error('Error opening contact us link', { url }, e)
    Alert.alert(I18n.t('CannotOpenEmail.title'), I18n.t('CannotOpenEmail.body'), [
      { text: I18n.t('CannotOpenEmail.ok') },
    ])
  }
}
